<template>
  <div>
    <v-container
      :style="{
        padding: $vuetify.breakpoint.mobile ? undefined : '0px 120px 0px 120px',
      }"
    >
      <QuestionForm :config="false" :webform_theme="webform_theme" />
    </v-container>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import jwtDecode from "jwt-decode";
import QuestionForm from "../../components/FormUI/QuestionForm.vue";
export default {
  props: ["config"],
  components: { QuestionForm },
  data() {
    return {
      webform_theme: {
        bg_color: "#FBFBFBFF",
        bg_image: false,
        bg_image_url: "",
        bg_repeat: "repeat",
        bg_position_x: "left",
        bg_position_y: "top",
        bg_size: "auto",
        header_bg: "#395DA5FF",
        header_text: "#FFFFFFFF",
        title: "",
        subtitle: "",
        logo: false,
        logo_type: "normal",
        banner_size: 100,
        logo_image: {
          url: "",
          size: 50,
          rounded: "circle",
          align: "center",
          margin: true,
        },
        checkbox_row: false,
        radio_row: false,
        q_bgcolor: "#FFFFFFFF",
        q_text_color: "#000000",
        q_border_px: 1,
        q_border_color: "#0000001f",
        ans_color: "#395da5",
        ans_bgcolor: "#FFFFFFFF",
        ans_text_color: "#000000",
        ans_border_px: 1,
        ans_border_color: "#0000001f",
        button: {
          bg_color: "#395DA5FF",
          text: "ถัดไป >>",
          text_color: "#FFFFFFFF",
          bt_texttype: "button",
        },
        restart_button: {
          bg_color: "#395DA5FF",
          text: "เริ่มใหม่",
          text_color: "#395DA5",
          bt_texttype: "outlined",
        },
      },
    };
  },
  created() {
    if (this.$route.query) {
      this.getSurveyByID();
    }
  },
  methods: {
    getSurveyByID() {
      this.$store
        .dispatch("getSurveyByID", this.$route.query.surveyID)
        .then((response) => {
          // console.log(response);
          this.$store.state.surveyInfoNoCookie.surveyName =
            response.data.surveyName;
          this.$store.state.surveyInfoNoCookie.surveyDetail =
            response.data.surveyDetail;
          if (response.data.webform_theme) {
            if (response.data.webform_theme.q_bgcolor) {
              this.webform_theme = response.data.webform_theme;
            }
          }
          document.getElementById("app").style.backgroundColor =
            this.webform_theme.bg_color;
          document.getElementById("app").style.backgroundImage = this
            .webform_theme.bg_image
            ? `url(${this.webform_theme.bg_image_url})`
            : "";
          document.getElementById(
            "app"
          ).style.backgroundPosition = `${this.webform_theme.bg_position_x} ${this.webform_theme.bg_position_y}`;
          document.getElementById("app").style.backgroundRepeat =
            this.webform_theme.bg_repeat;
          document.getElementById("app").style.backgroundSize =
            this.webform_theme.bg_size;
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            text:
              Object.keys(err.data).length === 0
                ? "ไม่พบแบบสอบถาม"
                : "ไม่สามารถดึงข้อมูล survey ได้",
            title: "",
          }).then(() => {
            if (this.$route.query.shared_token) {
              this.CloseQuestion();
            }
          });
        });
    },
    CloseQuestion() {
      let jwtdata = jwtDecode(this.$route.query.shared_token);
      if (this.$route.query.socialType) {
        if (
          this.$route.query.socialType === "ONECHAT" &&
          this.$route.query.token &&
          this.$route.query.socialID
        ) {
          let jwtdataonechat = jwtDecode(jwtdata.access_token);
          this.$axios.post(
            "https://chat-api.one.th/message/api/v2/disable_webview",
            {
              user_id: jwtdataonechat.sub,
              bot_id: this.$route.query.socialID,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$route.query.token,
              },
            }
          );
        } else if (
          this.$route.query.socialType === "ONEPLATFORM" &&
          this.$route.query.token
        ) {
          this.$axios.post(
            "https://platform.one.th/chat/api/v1/chatbot-api/close-web-view",
            {
              one_id: jwtdata.sub,
            },
            {
              headers: {
                Authorization: "Bearer " + this.$route.query.token,
              },
            }
          );
        } else if (this.$route.query.socialType === "FACEBOOK") {
          Swal.fire({
            html: "กดปุ่มขวาบนเพื่อปิดหน้าเว็บ",
            icon: "success",
            showCancelButton: false,
            showConfirmButton: false,
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            confirmButtonColor: "#0093cc",
            confirmButtonText: "รับทราบ",
          });
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
